import React, { useState } from "react";
import { Fab } from "react-tiny-fab";
import Navbar from "../component/Navbar";
import About from "./About";
import Skills from "./Skills";
import "./fab.css";
import Hero from "./Hero";
import MediaSocial from "./MediaSocial";
import * as Scroll from "react-scroll";

const Main = () => {
  const [scroll, setScroll] = useState(false);
  let data = Scroll.animateScroll;
  const onChangeHandler = () => {
    if (window.scrollY > 100) {
      setScroll(true);
      document.body.className = "scrollbar-default";
    } else {
      setScroll(false);
      document.body.className = "scrollbar-hide";
    }
  };

  const onClickTop = () => {
    data.scrollToTop();
  };

  window.addEventListener("scroll", onChangeHandler);
  return (
    <div>
      <section style={{ zIndex: "1" }} className="header fixed min-w-full">
        <Navbar />
      </section>

      <section className="content" style={{ zIndex: "-1" }}>
        <div className="hero">
          <Hero />
        </div>
        <div
          id="about"
          className="about flex flex-col items-center sm:mt-100 lg:p-40 sm:p-20"
        >
          <About />
        </div>
        <div
          id="skills"
          className="skills sm:mt-100 pt-10 pb-24 bg-sky-500 text-white"
        >
          <Skills />
        </div>
        <div id="medsos" className="medsos p-28">
          <MediaSocial />
        </div>
      </section>

      <section className="footer">
        {!scroll ? (
          ""
        ) : (
          <Fab
            event={true}
            onClick={() => onClickTop()}
            icon={<i class="fa-solid fa-chevron-up hover:text-2xl"></i>}
          ></Fab>
        )}
        <div className="py-10 bg-gradient-to-r from-cyan-500 to-blue-500">
          <p className="text-3xl font-bold text-white">
            <i class="fa-solid fa-code"></i> gozza
          </p>
        </div>
      </section>
    </div>
  );
};

export default Main;
